import React, { FC } from 'react';
import { KeyboardDatePicker as MuiKeyboardDatePicker } from '@material-ui/pickers';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '../Typography';
import Icon from '../Icon';
import CalendarAlt from '../Icon/icons/outlined/calendar-alt';
import { DatePickerProps, InvalidDateMsgProps } from './types';
import styles, { popOverStyles, keyBoardButtonStyles, inputAdornmentStyles } from './style';

const StyledMuiKeyBoardDatePicker = withStyles(styles)(MuiKeyboardDatePicker);
const usePopOverStyles = makeStyles(popOverStyles);
const useKeyboardButtonStyles = makeStyles(keyBoardButtonStyles);
const useInputAdornmentStyles = makeStyles(inputAdornmentStyles);

const CommonKeyboardDatePickerProps = {
  keyboardIcon: <Icon icon={CalendarAlt} />,
  maxDateMessage: null,
  minDateMessage: null,
  inputVariant: 'outlined',
  disableToolbar: true,
  disableFuture: true,
  variant: 'inline',
  format: 'yyyy/MM/dd',
  InputAdornmentProps: {
    position: 'start',
  },
  margin: "normal",
  autoOk: true,
} as const;

const InvalidDateMsg: FC<InvalidDateMsgProps> = ({ msg }) => (
  <Typography variant='span' color='error'>
    {msg}
  </Typography>
)

const KeyboardDatePicker: FC<DatePickerProps> = ({
  value,
  onChange,
  placeholder,
  label,
  minDate,
  maxDate,
  invalidDateMsg = 'Invalid date',
  ...restProps
}) => {
  const popOverClasses = usePopOverStyles();
  const CommonKeyboardDatePickerClassProps = {
    PopoverProps: {
      PaperProps: {
        classes: {
          root: popOverClasses.root
        }
      }
    }
  };

  const inputAdornmentClasses = useInputAdornmentStyles();
  const KeyboardDatePickerClassProps = {
    ...CommonKeyboardDatePickerProps,
    ...CommonKeyboardDatePickerClassProps,
    InputAdornmentProps: {
      ...CommonKeyboardDatePickerProps.InputAdornmentProps,
      classes: inputAdornmentClasses,
    },
  };

  const keyboardButtonStyles = useKeyboardButtonStyles();
  const KeyboardButtonProps = {
    edge: 'start',
    size: 'small',
    classes: {
      root: keyboardButtonStyles.root
    },
    color: 'primary'
  } as const;

  return (
    <StyledMuiKeyBoardDatePicker
      label={label}
      placeholder={placeholder}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      onChange={onChange}
      KeyboardButtonProps={KeyboardButtonProps}
      invalidDateMessage={<InvalidDateMsg msg={invalidDateMsg} />}
      {...KeyboardDatePickerClassProps}
      {...restProps}
    />
  );
};

export default KeyboardDatePicker;
